import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiService } from './base-api/api.service';
import { AdminCreationDraft } from '../models/admin-creation-draft';
import { AdminDraftType } from '../models/admin-draft-type';

@Injectable({ providedIn: 'root' })
export class AdminCreationDraftApiService {
  private readonly api = inject(ApiService);

  get<T>(draftType: AdminDraftType): Observable<AdminCreationDraft<T> | undefined> {
    return this.api.get<{ data: AdminCreationDraft<T> | null }>(`admin-creation-drafts/${draftType}`).pipe(
      // The API answers with a null payload while nothing has been saved yet, so
      // an unsaved draft is normalised to undefined instead of an error.
      map(response => response.data ?? undefined),
    );
  }

  save<T>(draftType: AdminDraftType, displayName: string, payload: T): Observable<{ saved: boolean }> {
    return this.api.put(`admin-creation-drafts/${draftType}`, { displayName, payload });
  }

  delete(draftType: AdminDraftType): Observable<{ deleted: boolean }> {
    return this.api.delete(`admin-creation-drafts/${draftType}`);
  }
}
